import React, { useState } from 'react';
import { DataTable } from '../components/DataTable';
import { WizardForm } from '../components/WizardForm';
import { StatusBadge } from '../components/StatusBadge';
export function VesselManagement() {
  const [activeTab, setActiveTab] = useState<'list' | 'register'>('list');
  const [currentStep, setCurrentStep] = useState(0);
  const [vessels, setVessels] = useState([{
    vesselId: 'VSL-001',
    vesselName: 'MV Sundarban-1',
    regNumber: 'REG-2024-001',
    ownerName: 'Rahim Uddin',
    vesselType: 'Trawler',
    contactNumber: '01711223344',
    email: 'rahim@vessel.com',
    status: 'active' as const
  }, {
    vesselId: 'VSL-002',
    vesselName: 'FV Padma-3',
    regNumber: 'REG-2024-002',
    ownerName: 'Karim Sheikh',
    vesselType: 'Boat',
    contactNumber: '01811334455',
    email: 'karim@vessel.com',
    status: 'active' as const
  }, {
    vesselId: 'VSL-003',
    vesselName: 'BT Meghna-7',
    regNumber: 'REG-2024-003',
    ownerName: 'Abdul Hakim',
    vesselType: 'Ship',
    contactNumber: '01911445566',
    email: 'abdul@vessel.com',
    status: 'expired' as const
  }, {
    vesselId: 'VSL-004',
    vesselName: 'LV Jamuna-2',
    regNumber: 'REG-2024-004',
    ownerName: 'Jamal Hossain',
    vesselType: 'Launch',
    contactNumber: '01611556677',
    email: 'jamal@vessel.com',
    status: 'active' as const
  }, {
    vesselId: 'VSL-005',
    vesselName: 'FT Karnaphuli-5',
    regNumber: 'REG-2024-005',
    ownerName: 'Fatema Begum',
    vesselType: 'Trawler',
    contactNumber: '01511667788',
    email: 'fatema@vessel.com',
    status: 'suspended' as const
  }]);
  const [formData, setFormData] = useState({
    vesselName: '',
    regNumber: '',
    regDate: '',
    issuingAuthority: '',
    blcNo: '',
    licenseIssueDate: '',
    licenseExpiryDate: '',
    vesselLength: '',
    vesselWidth: '',
    depthDraft: '',
    engineType: '',
    engineNumber: '',
    enginePower: '',
    fuelType: '',
    carryingCapacity: '',
    vesselType: '',
    operatingArea: '',
    ownerName: '',
    ownerNid: '',
    contactNumber: '',
    emailAddress: '',
    address: '',
    organization: '',
    village: '',
    union: '',
    upazila: '',
    district: '',
    range: '',
    route: '',
    blcAttachment: ''
  });
  const columns = [{
    key: 'vesselId',
    label: 'Vessel ID'
  }, {
    key: 'vesselName',
    label: 'Vessel Name'
  }, {
    key: 'regNumber',
    label: 'Registration Number'
  }, {
    key: 'ownerName',
    label: 'Owner Name'
  }, {
    key: 'vesselType',
    label: 'Vessel Type'
  }, {
    key: 'contactNumber',
    label: 'Contact Number'
  }, {
    key: 'email',
    label: 'Email'
  }, {
    key: 'status',
    label: 'Status',
    render: (value: string) => <StatusBadge status={value as any} data-id="element-3056" data-mp="30xonwyr11npw" />
  }];
  const filters = [{
    key: 'vesselType',
    label: 'Vessel Type',
    options: ['Boat', 'Launch', 'Ship', 'Trawler']
  }, {
    key: 'status',
    label: 'Status',
    options: ['Active', 'Expired', 'Suspended']
  }];
  const wizardSteps = [{
    title: 'Vessel Details',
    description: 'Enter vessel and technical information'
  }, {
    title: 'Owner & Location',
    description: 'Enter owner and operational details'
  }, {
    title: 'Documents',
    description: 'Upload required certificates'
  }, {
    title: 'Review & Submit',
    description: 'Review all information before submitting'
  }];
  return <div className="space-y-6" data-id="element-3057" data-mp="2ea1hyp4khuy6">
      <div data-id="element-3058" data-mp="2eaugx3xabg5r">
        <h1 className="text-2xl font-bold text-gray-900" data-id="element-3059" data-mp="2ebclcnu3p0or">Vessel Management</h1>
        <p className="text-sm text-gray-600 mt-1" data-id="element-3060" data-mp="giyinbmhcbgg">
          Manage boat registrations and licenses
        </p>
      </div>

      <div className="border-b border-gray-200" data-id="element-3061" data-mp="cfsdk7b3sqbk">
        <div className="flex gap-4" data-id="element-3062" data-mp="jktlknohbmuc">
          <button onClick={() => setActiveTab('list')} className={`px-4 py-2 border-b-2 font-medium text-sm transition-colors ${activeTab === 'list' ? 'border-[#1B5E20] text-[#1B5E20]' : 'border-transparent text-gray-600 hover:text-gray-900'}`} data-id="element-3063" data-mp="jlw8kkiol54z">
            Vessel Registry
          </button>
          <button onClick={() => setActiveTab('register')} className={`px-4 py-2 border-b-2 font-medium text-sm transition-colors ${activeTab === 'register' ? 'border-[#1B5E20] text-[#1B5E20]' : 'border-transparent text-gray-600 hover:text-gray-900'}`} data-id="element-3064" data-mp="uloonbdhsml">
            Register Vessel
          </button>
        </div>
      </div>

      {activeTab === 'list' ? <DataTable columns={columns} data={vessels} filters={filters} onDataChange={setVessels} searchPlaceholder="Search vessels..." data-id="element-3065" data-mp="3e158m9ukkwvp" /> : <WizardForm steps={wizardSteps} currentStep={currentStep} onStepChange={setCurrentStep} onSubmit={() => {
      if (!formData.vesselName || !formData.regNumber) {
        alert('Please fill in all required fields.');
        return;
      }
      alert('Vessel registered successfully!');
      setCurrentStep(0);
      setActiveTab('list');
      setFormData({
        vesselName: '',
        regNumber: '',
        regDate: '',
        issuingAuthority: '',
        blcNo: '',
        licenseIssueDate: '',
        licenseExpiryDate: '',
        vesselLength: '',
        vesselWidth: '',
        depthDraft: '',
        engineType: '',
        engineNumber: '',
        enginePower: '',
        fuelType: '',
        carryingCapacity: '',
        vesselType: '',
        operatingArea: '',
        ownerName: '',
        ownerNid: '',
        contactNumber: '',
        emailAddress: '',
        address: '',
        organization: '',
        village: '',
        union: '',
        upazila: '',
        district: '',
        range: '',
        route: '',
        blcAttachment: ''
      });
    }} data-id="element-3066" data-mp="2zeeto5nxb5rn">
          {currentStep === 0 && <div className="space-y-4" data-id="element-3067" data-mp="3cgpl627pmnqr">
              <div className="grid grid-cols-2 gap-4" data-id="element-3068" data-mp="3cjvbtlvzlxol">
                <div data-id="element-3069" data-mp="3hfsrdpzff00b">
                  <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-3070" data-mp="3hfanq8afpjid">
                    Vessel Name *
                  </label>
                  <input type="text" required value={formData.vesselName} onChange={e => setFormData({
              ...formData,
              vesselName: e.target.value
            })} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1B5E20]" data-id="element-3071" data-mp="3qhjz10dj1gwt" />
                </div>
                <div data-id="element-3072" data-mp="1etopgr2excl2">
                  <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-3073" data-mp="1euzvyyn8syfv">
                    Registration Number *
                  </label>
                  <input type="text" required value={formData.regNumber} onChange={e => setFormData({
              ...formData,
              regNumber: e.target.value
            })} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1B5E20]" data-id="element-3074" data-mp="27ivodr5s446u" />
                </div>
              </div>
              <div className="grid grid-cols-2 gap-4" data-id="element-3075" data-mp="i2wajwr7tqkv">
                <div data-id="element-3076" data-mp="2i66xjueq8po6">
                  <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-3077" data-mp="2i5npd5evpfnc">
                    Registration Date
                  </label>
                  <input type="date" value={formData.regDate} onChange={e => setFormData({
              ...formData,
              regDate: e.target.value
            })} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1B5E20]" data-id="element-3078" data-mp="2m93ktyf7p9yg" />
                </div>
                <div data-id="element-3079" data-mp="2r62b25vr8wrd">
                  <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-3080" data-mp="2r4rbki9ceb62">
                    Issuing Authority
                  </label>
                  <input type="text" value={formData.issuingAuthority} onChange={e => setFormData({
              ...formData,
              issuingAuthority: e.target.value
            })} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1B5E20]" data-id="element-3081" data-mp="3jv9bjaerrwf9" />
                </div>
              </div>
              <div className="grid grid-cols-3 gap-4" data-id="element-3082" data-mp="1hza7uybzgmia">
                <div data-id="element-3083" data-mp="u84sek9yfw8i">
                  <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-3084" data-mp="u7mor2kyqfqk">
                    BLC No.
                  </label>
                  <input type="text" value={formData.blcNo} onChange={e => setFormData({
              ...formData,
              blcNo: e.target.value
            })} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1B5E20]" data-id="element-3085" data-mp="pb60m8drk1dh" />
                </div>
                <div data-id="element-3086" data-mp="jho5kx7eqido">
                  <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-3087" data-mp="ji7q8lofzkve">
                    License Issue Date
                  </label>
                  <input type="date" value={formData.licenseIssueDate} onChange={e => setFormData({
              ...formData,
              licenseIssueDate: e.target.value
            })} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1B5E20]" data-id="element-3088" data-mp="9so0qx684srk" />
                </div>
                <div data-id="element-3089" data-mp="3iyw5vnjqoqx4">
                  <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-3090" data-mp="3izfnf35h9dam">
                    License Expiry Date
                  </label>
                  <input type="date" value={formData.licenseExpiryDate} onChange={e => setFormData({
              ...formData,
              licenseExpiryDate: e.target.value
            })} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1B5E20]" data-id="element-3091" data-mp="1h6rhgm1g8br5" />
                </div>
              </div>
              <div className="grid grid-cols-3 gap-4" data-id="element-3092" data-mp="2g6a629n15ouj">
                <div data-id="element-3093" data-mp="2g7lc6g3y78ot">
                  <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-3094" data-mp="2l4boqtgjnm5h">
                    Vessel Length
                  </label>
                  <input type="text" value={formData.vesselLength} onChange={e => setFormData({
              ...formData,
              vesselLength: e.target.value
            })} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1B5E20]" data-id="element-3095" data-mp="2p5f4zh2i7k78" />
                </div>
                <div data-id="element-3096" data-mp="21ftwqahh5drq">
                  <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-3097" data-mp="21gc3i11rjadw">
                    Vessel Width
                  </label>
                  <input type="text" value={formData.vesselWidth} onChange={e => setFormData({
              ...formData,
              vesselWidth: e.target.value
            })} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1B5E20]" data-id="element-3098" data-mp="2ahjqvo2qqqt7" />
                </div>
                <div data-id="element-3099" data-mp="140y689e31jwo">
                  <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-3100" data-mp="140g10n9fzvcm">
                    Depth / Draft
                  </label>
                  <input type="text" value={formData.depthDraft} onChange={e => setFormData({
              ...formData,
              depthDraft: e.target.value
            })} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1B5E20]" data-id="element-3101" data-mp="z00qe3gjp1yc" />
                </div>
              </div>
              <div className="grid grid-cols-3 gap-4" data-id="element-3102" data-mp="3te559viqte60">
                <div data-id="element-3103" data-mp="28lsep5038ux">
                  <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-3104" data-mp="28vmant6205w">
                    Engine Type
                  </label>
                  <input type="text" value={formData.engineType} onChange={e => setFormData({
              ...formData,
              engineType: e.target.value
            })} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1B5E20]" data-id="element-3105" data-mp="3pe4hhk9r7qma" />
                </div>
                <div data-id="element-3106" data-mp="2jj1cquzjn2w5">
                  <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-3107" data-mp="2ji9q49nxcfi0">
                    Engine Number
                  </label>
                  <input type="text" value={formData.engineNumber} onChange={e => setFormData({
              ...formData,
              engineNumber: e.target.value
            })} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1B5E20]" data-id="element-3108" data-mp="2fjan4ulr6st7" />
                </div>
                <div data-id="element-3109" data-mp="1rt6lgss4l34u">
                  <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-3110" data-mp="1rpirxtmokgq4">
                    Engine Power (HP)
                  </label>
                  <input type="text" value={formData.enginePower} onChange={e => setFormData({
              ...formData,
              enginePower: e.target.value
            })} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1B5E20]" data-id="element-3111" data-mp="2bsx9fqnh6v6" />
                </div>
              </div>
              <div className="grid grid-cols-3 gap-4" data-id="element-3112" data-mp="pz107r0lw3u1">
                <div data-id="element-3113" data-mp="uzor8cou4ko9">
                  <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-3114" data-mp="uz5kls4mxipj">
                    Fuel Type
                  </label>
                  <select value={formData.fuelType} onChange={e => setFormData({
              ...formData,
              fuelType: e.target.value
            })} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1B5E20]" data-id="element-3115" data-mp="z07j26qq9qqg">
                    <option value="" data-id="element-3116" data-mp="gybmrj53b66p">Select Fuel</option>
                    <option value="Diesel" data-id="element-3117" data-mp="gzwgx7nhsn41">Diesel</option>
                    <option value="Petrol" data-id="element-3118" data-mp="cwqde7rrla19">Petrol</option>
                    <option value="CNG" data-id="element-3119" data-mp="cz2pw5er6s6x">CNG</option>
                    <option value="Manual" data-id="element-3120" data-mp="qvpqci5x00hl">Manual</option>
                  </select>
                </div>
                <div data-id="element-3121" data-mp="lwmsbhocquj4">
                  <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-3122" data-mp="lxegi7fmdpzd">
                    Carrying Capacity
                  </label>
                  <input type="text" value={formData.carryingCapacity} onChange={e => setFormData({
              ...formData,
              carryingCapacity: e.target.value
            })} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1B5E20]" data-id="element-3123" data-mp="vmxzdd3c1ju8" />
                </div>
                <div data-id="element-3124" data-mp="1f9sut7aw05oi">
                  <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-3125" data-mp="1f881fl0b6ss8">
                    Vessel Type
                  </label>
                  <select value={formData.vesselType} onChange={e => setFormData({
              ...formData,
              vesselType: e.target.value
            })} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1B5E20]" data-id="element-3126" data-mp="1jcphb93jslxq">
                    <option value="" data-id="element-3127" data-mp="mkc3ye2x0wue">Select Type</option>
                    <option value="Boat" data-id="element-3128" data-mp="mmotbcb069hh">Boat</option>
                    <option value="Launch" data-id="element-3129" data-mp="rinfqucrthf9">Launch</option>
                    <option value="Ship" data-id="element-3130" data-mp="171on4tva6rws">Ship</option>
                    <option value="Trawler" data-id="element-3131" data-mp="170dhspm6tc3k">Trawler</option>
                  </select>
                </div>
              </div>
              <div data-id="element-3132" data-mp="120isurlz2wl5">
                <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-3133" data-mp="x3imefl7nrti">
                  Operating Area
                </label>
                <input type="text" value={formData.operatingArea} onChange={e => setFormData({
            ...formData,
            operatingArea: e.target.value
          })} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1B5E20]" data-id="element-3134" data-mp="t0vtebct00uq" />
              </div>
            </div>}

          {currentStep === 1 && <div className="space-y-4" data-id="element-3135" data-mp="5efgywhl8bfa">
              <div className="grid grid-cols-2 gap-4" data-id="element-3136" data-mp="cq89nhu89ud">
                <div data-id="element-3137" data-mp="fcn88725rmm">
                  <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-3138" data-mp="2c0lhtwsyce64">
                    Owner Name *
                  </label>
                  <input type="text" required value={formData.ownerName} onChange={e => setFormData({
              ...formData,
              ownerName: e.target.value
            })} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1B5E20]" data-id="element-3139" data-mp="2gydc2xh2kcdh" />
                </div>
                <div data-id="element-3140" data-mp="229h6d72hjbg1">
                  <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-3141" data-mp="228yzlgi75etv">
                    Owner NID / Passport No.
                  </label>
                  <input type="text" value={formData.ownerNid} onChange={e => setFormData({
              ...formData,
              ownerNid: e.target.value
            })} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1B5E20]" data-id="element-3142" data-mp="19l34gg89zuz7" />
                </div>
              </div>
              <div className="grid grid-cols-2 gap-4" data-id="element-3143" data-mp="zy7xh30hsrm2">
                <div data-id="element-3144" data-mp="2c241j9jvr1k">
                  <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-3145" data-mp="2cjzwesaw38y">
                    Contact Number
                  </label>
                  <input type="tel" value={formData.contactNumber} onChange={e => setFormData({
              ...formData,
              contactNumber: e.target.value
            })} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1B5E20]" data-id="element-3146" data-mp="78skw8t6iqo1" />
                </div>
                <div data-id="element-3147" data-mp="3d5h6yg09kq45">
                  <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-3148" data-mp="3875zgbxfyrp3">
                    Email Address
                  </label>
                  <input type="email" value={formData.emailAddress} onChange={e => setFormData({
              ...formData,
              emailAddress: e.target.value
            })} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1B5E20]" data-id="element-3149" data-mp="3371jcn0g3yze" />
                </div>
              </div>
              <div data-id="element-3150" data-mp="2fk1prtnelp6z">
                <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-3151" data-mp="2fgdx0wps96tb">
                  Address
                </label>
                <textarea rows={2} value={formData.address} onChange={e => setFormData({
            ...formData,
            address: e.target.value
          })} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1B5E20]" data-id="element-3152" data-mp="26i29x4o4kr5m" />
              </div>
              <div className="grid grid-cols-2 gap-4" data-id="element-3153" data-mp="1rvd7ov2hnzvj">
                <div data-id="element-3154" data-mp="2fkfq454y5wr3">
                  <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-3155" data-mp="2fl7m3h2ghwhw">
                    Organization
                  </label>
                  <select value={formData.organization} onChange={e => setFormData({
              ...formData,
              organization: e.target.value
            })} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1B5E20]" data-id="element-3156" data-mp="25uw6uydbo0vp">
                    <option value="" data-id="element-3157" data-mp="3co0rhmdib8qz">Select Organization</option>
                    <option value="Sundarban Fisheries Ltd" data-id="element-3158" data-mp="38nqhzzqia07d">
                      Sundarban Fisheries Ltd
                    </option>
                    <option value="Bay of Bengal Trading Co." data-id="element-3159" data-mp="3mdk8emhnssj7">
                      Bay of Bengal Trading Co.
                    </option>
                    <option value="Khulna Honey Producers" data-id="element-3160" data-mp="3hi4xa2b1daqh">
                      Khulna Honey Producers
                    </option>
                    <option value="Mongla Port Services" data-id="element-3161" data-mp="2pp4fqhj9631v">
                      Mongla Port Services
                    </option>
                    <option value="Satkhira Wood Industries" data-id="element-3162" data-mp="33p6z6877l4j8">
                      Satkhira Wood Industries
                    </option>
                  </select>
                </div>
                <div data-id="element-3163" data-mp="ix3qtqrh4el3">
                  <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-3164" data-mp="iwln692hey35">
                    Village
                  </label>
                  <select value={formData.village} onChange={e => setFormData({
              ...formData,
              village: e.target.value
            })} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1B5E20]" data-id="element-3165" data-mp="2jnccxfy8hv76">
                    <option value="" data-id="element-3166" data-mp="32l6skctvb4yj">Select Village</option>
                    <option value="Munshiganj" data-id="element-3167" data-mp="37lbbe9i90brx">Munshiganj</option>
                    <option value="Gabura" data-id="element-3168" data-mp="37jqc66kzo4nq">Gabura</option>
                    <option value="Shyamnagar" data-id="element-3169" data-mp="3cbhz874xrs94">Shyamnagar</option>
                    <option value="Koyra" data-id="element-3170" data-mp="3cedvlr14y8vg">Koyra</option>
                    <option value="Dacope" data-id="element-3171" data-mp="3h9t6qb7rdqo6">Dacope</option>
                  </select>
                </div>
              </div>
              <div className="grid grid-cols-3 gap-4" data-id="element-3172" data-mp="3lej1fwqokz7i">
                <div data-id="element-3173" data-mp="3qb15eue6stis">
                  <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-3174" data-mp="3qckhs9wq2kfa">
                    Union
                  </label>
                  <select value={formData.union} onChange={e => setFormData({
              ...formData,
              union: e.target.value
            })} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1B5E20]" data-id="element-3175" data-mp="1em309zut1yks">
                    <option value="" data-id="element-3176" data-mp="1tctsh90b6zof">Select Union</option>
                    <option value="Burigoalini" data-id="element-3177" data-mp="1tfg87vxcslhq">Burigoalini</option>
                    <option value="Gabura" data-id="element-3178" data-mp="1olc19co38dgn">Gabura</option>
                    <option value="Munshiganj" data-id="element-3179" data-mp="1jnsbbfi12c8v">Munshiganj</option>
                    <option value="Koyra" data-id="element-3180" data-mp="1jna9m3clj5tk">Koyra</option>
                    <option value="Dacope" data-id="element-3181" data-mp="2h3652x6i1klc">Dacope</option>
                  </select>
                </div>
                <div data-id="element-3182" data-mp="2cb6cjpsrdtys">
                  <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-3183" data-mp="2camwkemo5fne">
                    Upazila
                  </label>
                  <select value={formData.upazila} onChange={e => setFormData({
              ...formData,
              upazila: e.target.value
            })} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1B5E20]" data-id="element-3184" data-mp="307jf27p50srl">
                    <option value="" data-id="element-3185" data-mp="2hhbffzknckg5">Select Upazila</option>
                    <option value="Shyamnagar" data-id="element-3186" data-mp="23ha57tihs0o0">Shyamnagar</option>
                    <option value="Koyra" data-id="element-3187" data-mp="23iv1bnkgfrnz">Koyra</option>
                    <option value="Dacope" data-id="element-3188" data-mp="27ic8clfj4wv9">Dacope</option>
                    <option value="Mongla" data-id="element-3189" data-mp="27kydyfiv12au">Mongla</option>
                    <option value="Sarankhola" data-id="element-3190" data-mp="1qypecudkfso">Sarankhola</option>
                  </select>
                </div>
                <div data-id="element-3191" data-mp="5q7lhocw0pre">
                  <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-3192" data-mp="5pekz54iuwhp">
                    District
                  </label>
                  <select value={formData.district} onChange={e => setFormData({
              ...formData,
              district: e.target.value
            })} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1B5E20]" data-id="element-3193" data-mp="1m87t7ortmx6u">
                    <option value="" data-id="element-3194" data-mp="24xnz6rm9zhun">Select District</option>
                    <option value="Satkhira" data-id="element-3195" data-mp="2ixytk4msnekk">Satkhira</option>
                    <option value="Khulna" data-id="element-3196" data-mp="2iw4g1bduqoqi">Khulna</option>
                    <option value="Bagerhat" data-id="element-3197" data-mp="2e06zp52l9idq">Bagerhat</option>
                  </select>
                </div>
              </div>
              <div className="grid grid-cols-2 gap-4" data-id="element-3198" data-mp="okpm0idt634y">
                <div data-id="element-3199" data-mp="jlmgkwtx1uwg">
                  <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-3200" data-mp="jmefohmq2arh">
                    Range
                  </label>
                  <select value={formData.range} onChange={e => setFormData({
              ...formData,
              range: e.target.value
            })} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1B5E20]" data-id="element-3201" data-mp="3usqat3zn0vvi">
                    <option value="" data-id="element-3202" data-mp="3fxaawicdm5r7">Select Range</option>
                    <option value="Satkhira" data-id="element-3203" data-mp="3fxtv65pi168e">Satkhira</option>
                    <option value="Khulna" data-id="element-3204" data-mp="3kwdfy2scwbz6">Khulna</option>
                    <option value="Chandpai" data-id="element-3205" data-mp="3kyzn41bc4pgv">Chandpai</option>
                    <option value="Sarankhola" data-id="element-3206" data-mp="3pxazojt0le2s">Sarankhola</option>
                  </select>
                </div>
                <div data-id="element-3207" data-mp="10661qk9p1vuc">
                  <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-3208" data-mp="108sa2m4esfdm">
                    Route
                  </label>
                  <input type="text" value={formData.route} onChange={e => setFormData({
              ...formData,
              route: e.target.value
            })} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1B5E20]" data-id="element-3209" data-mp="2pnt6kuabqmx1" />
                </div>
              </div>
            </div>}

          {currentStep === 2 && <div className="space-y-4" data-id="element-3210" data-mp="1wyvyfjztu6i0">
              <div data-id="element-3211" data-mp="1wzxb1swhr11u">
                <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-3212" data-mp="1wze231otjmzy">
                  Boat License Certificate (BLC) Attachment
                </label>
                <input type="file" accept="image/*,application/pdf" className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1B5E20]" data-id="element-3213" data-mp="3rd5ajxvew0tt" />
                <p className="text-xs text-gray-500 mt-1" data-id="element-3214" data-mp="hwr2iahvhd6f">
                  Upload PDF or Image file
                </p>
              </div>
            </div>}

          {currentStep === 3 && <div className="space-y-6" data-id="element-3215" data-mp="rqhjkubo6lc3">
              <div className="bg-gray-50 rounded-lg p-4" data-id="element-3216" data-mp="mpacyyl9js70">
                <div className="flex items-center justify-between mb-3" data-id="element-3217" data-mp="mrwlb0fzabqa">
                  <h4 className="font-semibold text-gray-900" data-id="element-3218" data-mp="3v5lzh1s26w96">
                    Vessel Details
                  </h4>
                  <button onClick={() => setCurrentStep(0)} className="text-sm text-[#1B5E20] hover:underline" data-id="element-3219" data-mp="3q8n7opvvb1e5">
                    Edit
                  </button>
                </div>
                <div className="grid grid-cols-2 gap-3 text-sm" data-id="element-3220" data-mp="1kcj1z3kh3jdr">
                  <div data-id="element-3221" data-mp="1fe7u2ydqniy6">
                    <span className="text-gray-600" data-id="element-3222" data-mp="1ff0ttfea586t">Name:</span>{' '}
                    <span className="font-medium" data-id="element-3223" data-mp="1mxqixl9ny6eo">
                      {formData.vesselName || 'Not provided'}
                    </span>
                  </div>
                  <div data-id="element-3224" data-mp="1ryekh0viq5n5">
                    <span className="text-gray-600" data-id="element-3225" data-mp="1rugze9pdr40m">Reg No:</span>{' '}
                    <span className="font-medium" data-id="element-3226" data-mp="1dyn1elq59z2a">
                      {formData.regNumber || 'Not provided'}
                    </span>
                  </div>
                  <div data-id="element-3227" data-mp="25nq785xojhh1">
                    <span className="text-gray-600" data-id="element-3228" data-mp="25pjdhk4drzoi">Type:</span>{' '}
                    <span className="font-medium" data-id="element-3229" data-mp="2anunbuuoea6q">
                      {formData.vesselType || 'Not provided'}
                    </span>
                  </div>
                </div>
              </div>

              <div className="bg-gray-50 rounded-lg p-4" data-id="element-3230" data-mp="20x030w0zpknx">
                <div className="flex items-center justify-between mb-3" data-id="element-3231" data-mp="20vf835arjzpj">
                  <h4 className="font-semibold text-gray-900" data-id="element-3232" data-mp="2olj9d60hbndd">
                    Owner & Location
                  </h4>
                  <button onClick={() => setCurrentStep(1)} className="text-sm text-[#1B5E20] hover:underline" data-id="element-3233" data-mp="2tfx89iecocms">
                    Edit
                  </button>
                </div>
                <div className="grid grid-cols-2 gap-3 text-sm" data-id="element-3234" data-mp="2u8bohifdjnui">
                  <div data-id="element-3235" data-mp="2uaxrr5v8fh6x">
                    <span className="text-gray-600" data-id="element-3236" data-mp="2pajmfvl0mlcl">Owner Name:</span>{' '}
                    <span className="font-medium" data-id="element-3237" data-mp="2kax6vfhpst0m">
                      {formData.ownerName || 'Not provided'}
                    </span>
                  </div>
                  <div data-id="element-3238" data-mp="2finn6h770p6s">
                    <span className="text-gray-600" data-id="element-3239" data-mp="2fidu2kquq1wv">Contact:</span>{' '}
                    <span className="font-medium" data-id="element-3240" data-mp="2bj4zxerwg20s">
                      {formData.contactNumber || 'Not provided'}
                    </span>
                  </div>
                  <div data-id="element-3241" data-mp="21kp8tbsvgsra">
                    <span className="text-gray-600" data-id="element-3242" data-mp="21j4g7rq4bjw2">Organization:</span>{' '}
                    <span className="font-medium" data-id="element-3243" data-mp="1wl2x56sozkkl">
                      {formData.organization || 'Not provided'}
                    </span>
                  </div>
                </div>
              </div>
            </div>}
        </WizardForm>}
    </div>;
}